import enviro from 'enviro';
import { CMS_HUB_ENTERPRISE, CMS_HUB_PROFESSIONAL, COMMERCE_HUB_ENTERPRISE, COMMERCE_HUB_PROFESSIONAL, CRM_SUITE_STARTER_BUNDLE, MARKETING_HUB_ENTERPRISE, MARKETING_HUB_PROFESSIONAL, MARKETING_PLUS_ENTERPRISE_BUNDLE, MARKETING_PLUS_PROFESSIONAL_BUNDLE, OPERATIONS_HUB_ENTERPRISE, OPERATIONS_HUB_PROFESSIONAL, SALES_HUB_ENTERPRISE, SALES_HUB_PROFESSIONAL, SERVICE_HUB_ENTERPRISE, SERVICE_HUB_PROFESSIONAL } from 'self-service-api/constants/ApiNames';
export const TrialIds = {
  SALES_ENTERPRISE: 1,
  MARKETING_ENTERPRISE: 2,
  SERVICE_ENTERPRISE: 3,
  MARKETING_PRO: 4,
  CMS_PROFESSIONAL: 7,
  SALES_PROFESSIONAL: 8,
  SERVICE_PROFESSIONAL: 9,
  CMS_ENTERPRISE: enviro.isProd() ? 18 : 17,
  // Legacy Operations Hub Trial IDs
  OPERATIONS_PROFESSIONAL: enviro.isProd() ? 35096 : 43098,
  OPERATIONS_ENTERPRISE: enviro.isProd() ? 52399 : 70192,
  DATA_PROFESSIONAL: enviro.isProd() ? 247334 : 349115,
  DATA_ENTERPRISE: enviro.isProd() ? 247335 : 349116,
  MARKETING_PLUS_PROFESSIONAL_BUNDLE: enviro.isProd() ? 200098 : 270355,
  MARKETING_PLUS_ENTERPRISE_BUNDLE: enviro.isProd() ? 200097 : 270725,
  CRM_SUITE_STARTER_BUNDLE: enviro.isProd() ? 222377 : 318128,
  COMMERCE_PROFESSIONAL: enviro.isProd() ? 241458 : 349410,
  COMMERCE_ENTERPRISE: enviro.isProd() ? 241459 : 349411
};
export const apiNameToTrialIds = {
  [SALES_HUB_ENTERPRISE]: TrialIds.SALES_ENTERPRISE,
  [MARKETING_HUB_ENTERPRISE]: TrialIds.MARKETING_ENTERPRISE,
  [SERVICE_HUB_ENTERPRISE]: TrialIds.SERVICE_ENTERPRISE,
  [MARKETING_HUB_PROFESSIONAL]: TrialIds.MARKETING_PRO,
  [CMS_HUB_PROFESSIONAL]: TrialIds.CMS_PROFESSIONAL,
  [SALES_HUB_PROFESSIONAL]: TrialIds.SALES_PROFESSIONAL,
  [SERVICE_HUB_PROFESSIONAL]: TrialIds.SERVICE_PROFESSIONAL,
  [CMS_HUB_ENTERPRISE]: TrialIds.CMS_ENTERPRISE,
  [OPERATIONS_HUB_PROFESSIONAL]: TrialIds.DATA_PROFESSIONAL,
  [OPERATIONS_HUB_ENTERPRISE]: TrialIds.DATA_ENTERPRISE,
  [MARKETING_PLUS_PROFESSIONAL_BUNDLE]: TrialIds.MARKETING_PLUS_PROFESSIONAL_BUNDLE,
  [MARKETING_PLUS_ENTERPRISE_BUNDLE]: TrialIds.MARKETING_PLUS_ENTERPRISE_BUNDLE,
  [CRM_SUITE_STARTER_BUNDLE]: TrialIds.CRM_SUITE_STARTER_BUNDLE,
  [COMMERCE_HUB_PROFESSIONAL]: TrialIds.COMMERCE_PROFESSIONAL,
  [COMMERCE_HUB_ENTERPRISE]: TrialIds.COMMERCE_ENTERPRISE
};